export enum CliRequestStatus {
  AllCliRequests = 'allclirequests',
  InProgress = 'inprogress',
  Submitted = 'submitted',
  Approved = 'approved',
  Accepted = 'accepted',
  Declined = 'declined',
  Cancelled = 'cancelled',
}
